module.exports = __webpack_public_path__ + "static/media/astronaut.95e66bef.svg";